export enum EscalationType {
    FixedValue = 0,
    Multiplier = 1
}
